var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"denticao-report-line",attrs:{"data-id":'layer_tipoDenticao'}},[(_vm.execMode == _vm.gConsts.rt.execModes.WORK)?[_c('tipo-denticao-report-select')]:[_c('report-line-text',{attrs:{"text":_vm.selectedDenticaoReportText}})],_c('dentes-seg-report-line-text')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }